<template>
  <div>
    <div class="profile-info">
      <div class="profile-picture">
        <img src="../assets/svg/user-solid.svg" class="user-icon">
      </div>
      <div class="profile-name" :class="{'big-name': bigName}">
        {{ userFullName }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProfilePicture',
  props: {
    'userFullName': {
      type: String,
      required: true
    },
    'bigName': {
      type: Boolean,
      required: false,
      default: false,
    }
  },
}
</script>

<style scoped>
  .profile-info {
    display: flex;
    width: 100%;
    flex-direction: column;
    align-items: center;
    padding: 20px 0;
  }

  .profile-picture {
    background-color: #f5f5f5;
    width: 150px;
    height: 150px;
    border-radius: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .profile-name {
    font-weight: bold;
    font-size: 20px;
    margin: 30px 5px 0 5px;
  }

  .user-icon {
    width: 100px;
    height: 100px;
  }

  .big-name {
    font-size: 30px;
  }
</style>